import BaseModel from './base-model';
/**
 * format:
 * @COMMON_NAME: "3.- Normal"
 * @REL_ATTR: "3'"
 * @id: "502'"
 */
export default class Priority extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.id = opts['@id'] || null;
    this.name = opts['@COMMON_NAME'] || null;
    this.relAttr = opts['@REL_ATTR'] || null;
  }
}
